import type { StoplightState } from './types';

const LIGHTS: Array<{
  state: StoplightState;
  label: string;
  on: string;
  off: string;
}> = [
  {
    state: 'red',
    label: 'Early Development',
    on: 'bg-red-500 shadow-[0_0_7px_1px_rgba(239,68,68,0.85)]',
    off: 'bg-red-500/20',
  },
  {
    state: 'amber',
    label: 'Notes Welcome',
    on: 'bg-amber-400 shadow-[0_0_7px_1px_rgba(251,191,36,0.9)]',
    off: 'bg-amber-400/20',
  },
  {
    state: 'green',
    label: 'Final',
    on: 'bg-green-500 shadow-[0_0_7px_1px_rgba(34,197,94,0.85)]',
    off: 'bg-green-500/20',
  },
];

// Horizontal traffic-light pill indicating a slide's readiness/completeness.
// Exactly one light is lit; the others are dimmed. State mirrors the
// "Stoplight State" field at the top of the slide's md file. Each light
// carries its own hover tooltip explaining what that level means.
export function Stoplight({ state }: { state: StoplightState }) {
  const activeLabel = LIGHTS.find((l) => l.state === state)?.label ?? state;
  return (
    <div
      role="img"
      aria-label={`Slide readiness: ${activeLabel}`}
      className="inline-flex items-center gap-2 rounded-full bg-slate-900/90 px-2.5 py-1.5 shadow-md ring-1 ring-black/10"
    >
      {LIGHTS.map((light) => (
        <span
          key={light.state}
          title={light.label}
          className={`h-3 w-3 rounded-full transition ${
            state === light.state ? light.on : light.off
          }`}
        />
      ))}
    </div>
  );
}
